import { api } from './client';

/** Preferencias de pantalla por usuario (tanda 6). Prefijo: /api/preferencias (sin módulo). `valor` es null si no hay. */
export const leerPreferencia = async <T>(clave: string): Promise<T | null> =>
  (await api.get<{ valor: T | null }>(`/api/preferencias/${encodeURIComponent(clave)}`)).valor;

export const guardarPreferencia = async <T>(clave: string, valor: T): Promise<void> => {
  // `keepalive`: el guardado puede salir justo cuando la página se va (usePreferencia, en `pagehide`).
  await api.put<{ valor: T | null }>(`/api/preferencias/${encodeURIComponent(clave)}`, { valor }, { keepalive: true });
};
